import type React from 'react';
import Container from 'app/shared/core/Container';
import Row from 'app/shared/core/Row';
import { waitlistNotice } from './waitlistNotice.styles';

const WaitlistNotice: React.FC = () => {
  return (
    <div className={waitlistNotice}>
      <Row>
        <Container>Listing in high demand - join the waitlist!</Container>
      </Row>
    </div>
  );
};

WaitlistNotice.displayName = 'WaitlistNotice';

export default WaitlistNotice;
